export const QUERY_PARAM_DELIMITER = '§';

export interface Filters {
	tema?: string[];
	q?: string;
}

export const filtersToSearchParams = (filters: Filters) => {
	const searchParams = new URLSearchParams();

	if (filters.tema?.length) {
		searchParams.set('tema', filters.tema.join(QUERY_PARAM_DELIMITER));
	}

	if (filters.q?.length) {
		searchParams.set('q', filters.q);
	}

	return searchParams;
};

export const searchParamsToFilters = (searchParams: URLSearchParams) => {
	const filters: Filters = {
		tema: [],
	};

	searchParams.forEach((value, key) => {
		if (value) {
			if (key === 'tema') {
				filters.tema = value.split(QUERY_PARAM_DELIMITER);
			} else if (key === 'q') {
				filters.q = value;
			}
		}
	});

	return filters;
};
